import { render, staticRenderFns } from "./template16.vue?vue&type=template&id=bbd87f34&scoped=true"
import script from "./template16.vue?vue&type=script&lang=js"
export * from "./template16.vue?vue&type=script&lang=js"
import style0 from "./template16.vue?vue&type=style&index=0&id=bbd87f34&prod&scoped=true&lang=scss"
import style1 from "./template16.vue?vue&type=style&index=1&id=bbd87f34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd87f34",
  null
  
)

export default component.exports